import script from "./ScaleBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ScaleBox.vue?vue&type=script&setup=true&lang=js"

import "./ScaleBox.vue?vue&type=style&index=0&id=b7079e56&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.21_webpack@5.101.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7079e56"]])

export default __exports__